// import Firebase from '@/communication/Firebase'
// import { db } from '@/communication/FirebaseConfig'
import Toasted from 'vue-toasted'
import Vue from 'vue'

Vue.use(Toasted, {
  position: 'top-right',
  type: 'error',
  duration: 3000
})

export default async ({ commit, rootGetters }) => {
  // const userId = rootGetters['Login/GET_USER_ID']

  // const documentRef = db.collection(userId.toString())

  // documentRef.onSnapshot((doc) => {
  //   const alerts = []
  //   const messages = []

  //   doc.forEach(realtimeData => {
  //     const datas = realtimeData.data()

  //     switch (datas.type) {
  //       case 'alert':
  //         alerts.push(datas)
  //         break
  //       case 'message':
  //         messages.push(datas)
  //         break
  //       default:
  //         break
  //     }
  //   })

    // doc.docChanges().forEach(function (change) {
    //   if (change.type === 'added') {
    //     Vue.toasted.info('Você foi mencionado em uma tarefa')
    //   }
    // })

    // commit('SET_ALERTS', alerts)
    // commit('SET_MESSAGES', messages)
  // })
}



// WEBPACK FOOTER //
// ./src/brain/realtime/alerts/MapUser.js